import {
  SearchEntity,
  SearchFilterType,
  ReviewStatusType,
  User,
} from 'v2/models';
import { EditSearchData } from 'v2/pages/CreateSearch/CreateSearchSchema';

export enum REVIEW_STATUS {
  APPROVED = 'approved',
  UNDER_REVIEW = 'under_review',
  NEEDS_EDITING = 'needs_editting',
  DENIED = 'denied',
}

export const REVIEW_STATUS_TEXT = {
  [REVIEW_STATUS.APPROVED]: 'Approved',
  [REVIEW_STATUS.UNDER_REVIEW]: 'Pending Review',
  [REVIEW_STATUS.NEEDS_EDITING]: 'Needs attention',
  [REVIEW_STATUS.DENIED]: 'Rejected',
};

export function parseSearchFilter(
  value: SearchFilterType['data']['filter_value'],
  units: SearchFilterType['data']['filter_units']
) {
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No';
  } else if (units) {
    return `${value} ${units}`;
  } else if (
    typeof value === 'object' &&
    !Array.isArray(value) &&
    value?.list
  ) {
    return value.list.map((dataVendor) => dataVendor.name);
  }
  return value;
}

export function mapSearchToFormData(
  search: SearchEntity
): EditSearchData | null {
  if (!search) {
    return null;
  }
  const parsedFilters = search.filters.reduce(
    (acc, filter) => ({
      ...acc,
      [`${filter.filter.key}`]: getFilterValue(
        filter.filter.key as string,
        filter.data
      ),
    }),
    {}
  );

  const questions = search.questions.map((item) => ({
    id: item.id,
    value: item.name,
  }));

  return {
    id: search.id,
    name: search.name,
    extended: search.extended,
    description: search.description,
    hide_identity: search.hide_identity,
    filters: parsedFilters,
    post_questions: [...questions, { value: '' }],
    review_status: search.review_status,
    expiration_method: search.expires_at ? 'date' : 'manually_archive',
    expires_at: search.expires_at
      ? new Date(search.expires_at).toISOString()
      : '',
  };
}

export function isSearchAssignedToMe(
  search: SearchEntity,
  user: User
): boolean {
  return search.assigned_to?.username === user.username;
}

function getFilterValue(key: string, filterValue: SearchFilterType['data']) {
  if (Array.isArray(filterValue.filter_value)) {
    return filterValue.filter_value.map((item) => ({
      [key === 'exclude_providers' ? 'value' : 'name']: item,
    }));
  }
  if (key === 'exclude_providers_drm') {
    return filterValue.filter_value;
  }
  if (typeof filterValue.filter_value === 'boolean') {
    return filterValue.filter_value;
  }
  if (filterValue.filter_value && filterValue.filter_units) {
    return { unit: filterValue.filter_units, value: filterValue.filter_value };
  }
  if (
    typeof filterValue.filter_value === 'string' ||
    typeof filterValue.filter_value === 'number'
  ) {
    return filterValue.filter_value;
  }
  return null;
}

export const getReviewStatusText = (status: ReviewStatusType) => {
  return REVIEW_STATUS_TEXT[status];
};
